import React, { useMemo } from "react";

import { Stack } from "@mui/material";

import { AllocationDrift } from "../Allocation-drift/AllocationDrift";
import { usePortfolioConstructionContext } from "../Context/PortfolioConstructionContext";
import { ObjectivesPanel } from "../Objectives-panel/ObjectivesPanel";
import { NoPolicyBanner } from "./NoPolicyBaner";
import { CompareGraph } from "./Compare-graph/CompareGraph";
import { PieChartsBox } from "./Pie-chart/PieChartsBox";


export const DriftMonitoring: React.FC = () => {
  const {
    activeSliceKey,
    targetPolicy,
    permissions,
    onOpenTargetPolicy,
    compareGraph,
    compareGraphLoading,
    pieChart,
    pieChartLoading
  } = usePortfolioConstructionContext();

  const hasPolicyValues = useMemo(
    () => targetPolicy !== null && targetPolicy.some((item) => parseFloat(item.percentage) > 0),
    [targetPolicy]
  );
  const showNoPolicyBanner = activeSliceKey !== null && !hasPolicyValues;

  return (
    <Stack sx={{ width: "100%", gap: "16px" }}>
      {showNoPolicyBanner && <NoPolicyBanner canSet={permissions.canEditTargetPolicy} onSetPolicy={onOpenTargetPolicy} />}
      <ObjectivesPanel />
      <AllocationDrift />
      <CompareGraph loading={compareGraphLoading} data={compareGraph} />
      <Stack direction="row" gap="20px" justifyContent="space-between" mb="5px">
        <PieChartsBox loading={pieChartLoading} data={pieChart} />
      </Stack>
    </Stack>
  );
};
